module.exports = __webpack_public_path__ + "img/394.1e8b63be.jpg";